module.exports = __webpack_public_path__ + "static/media/lessons.a69df44e.svg";